// given a compEvent and a SocketResultMessagePayloadEntriesCheckIn payload
// return a new compEvent
import type { CompEvent, IndividualEntry } from '@/components/results/store-comp-results'
// import type { SocketResultMessagePayloadEntriesCheckIn } from '@/components/results/socket/entries-checkin/models/entries-checkin'
import { simpleClone } from '@/services/common-service-utils'
import type { SocketResultMessagePayloadEntriesCheckin } from '@/components/results/socket/entries-checkin/models/index'

export function updateEntriesCheckIn(
  compEvent: CompEvent,
  payload: SocketResultMessagePayloadEntriesCheckin
): CompEvent {
  const compEventInternal = simpleClone(compEvent)

  if (!compEventInternal.entries) {
    return compEventInternal
  }

  // loop thru checkedInEntryIds and update the checkedIn flag
  const checkInEntryIds = Object.keys(payload.checkins)

  // loop thru all compEventInternal.entries and update the checkedIn flag if entry id matches.
  const checkInIds = Object.keys(payload.checkins)
  console.log('checkInIds', checkInIds)

  const athleteIds = Object.keys(compEventInternal.entries)

  athleteIds.forEach((athleteId) => {
    const entry = compEventInternal.entries![athleteId]
    if (!entry) {
      return
    }

    const athleteCheckIn = payload.checkins[entry.entryId]

    if (athleteCheckIn) {
      entry.checkedIn = athleteCheckIn.checkedIn ? 1 : 0

      if (athleteCheckIn.checkedIn) {
        // If they have checked in, then they have also collected their bib !?!?!?!
        entry.collected = 1
      }
    }

    if (checkInIds.includes(entry.entryId.toString())) {
      entry.checkedIn = payload.checkins[entry.entryId.toString()].checkedIn ? 1 : 0
      // If they have checked in, then they have also collected their bib !?!?!?!
      entry.collected = 1
    }
  })

  return compEventInternal
}
